import styled from "styled-components";
import { PageBox } from "../../../styles/page";

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: auto;
  @media (min-height: 1080px) {
    justify-content: center;
  }

  > .top-title {
    font-family: Pretendard;
    font-size: 35px;
    font-weight: 700;
    text-align: left;
    padding: 50px 30px 0 30px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    > .ranking-board-button-wrapper {
      display: flex;
      flex-direction: row;
      gap: 20px;
      margin-right: 20px;

      > img {
        cursor: pointer;
      }
      > .ranking-board-button {
        width: 218px;
        height: 55px;
        flex-shrink: 0;
        border-radius: 13.898px;
        background: #2f3332;
        color: #fff;
        font-family: Pretendard;
        font-size: 18.531px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -0.371px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      }
    }
  }

  > .top-wrapper {
    display: flex;
    flex-direction: row;
    gap: 32px;
    padding: 30px 50px 0 30px;
  }

  > .bottom-wrapper {
    display: flex;
    flex-direction: row;
    gap: 20px;
    padding: 20px 50px 50px 30px;
  }
`;

export const NewUserWrapper = styled(PageBox)`
  flex: 992;
  position: relative;
  > .overlay {
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    background: var(--kakao-logo, #000);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
    font-family: Pretendard;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }

  > .wrapper {
    padding: 40px 80px 50px 30px;
    display: flex;
    flex-direction: row;
    gap: 80px;

    > .left-box {
      display: flex;
      flex-direction: column;
      gap: 20px;
      > .title {
        color: #121212;
        font-family: Pretendard;
        font-size: 25px;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        margin-bottom: 26px;
      }

      > .box {
        width: 226px;
        height: 147px;
        flex-shrink: 0;
        border-radius: 20px;
        background: #ecf0f3;
        display: flex;
        flex-direction: column;
        justify-content: center;
        gap: 11px;
        padding-left: 20px;

        > .value {
          color: #121212;
          font-family: Pretendard;
          font-size: 50px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }
      }
    }

    > .right-box {
      margin-top: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex: 1;
      > canvas {
        width: 100%;
        height: 100%;
      }
    }
  }

  #line {
    width: 0px;
    border-right: 2px dashed #422f8ade;
    position: absolute;
  }
`;
export const NoticeWrapper = styled(PageBox)`
  flex: 506;

  > .overlay {
    border-radius: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.7;
    background: var(--kakao-logo, #000);
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    text-align: center;
    font-family: Pretendard;
    font-size: 35px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
  }
  > .wrapper {
    padding: 40px;
    display: flex;
    flex-direction: column;
    position: relative;
    height: calc(100% - 80px);

    > .no-content {
      margin-top: 30px;
      overflow: hidden;
      color: #bebebe;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: -0.4px;
    }

    > .button {
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      bottom: 40px;
      width: calc(100% - 80px);
      height: 59px;
      flex-shrink: 0;
      border-radius: 15px;
      background: #ecf0f3;
      color: var(--kakao-logo, #000);
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: -0.4px;
    }
  }
`;
export const TodayTournamentWrapper = styled(PageBox)`
  flex: 584;
  height: 480px;

  > .wrapper {
    padding: 40px 30px 60px 30px;
    display: flex;
    flex-direction: column;
    > .title {
      color: var(--kakao-logo, #000);
      font-family: Pretendard;
      font-size: 25px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-bottom: 30px;
    }

    > .list-wrapper {
      display: flex;
      flex-direction: column;
      gap: 10px;

      > .no-tournament {
        overflow: hidden;
        color: #bebebe;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        letter-spacing: -0.4px;
      }

      > .item-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 6px 17px;
        width: calc(100% - 34px);
        height: calc(56px - 12px);
        border-radius: 15.04px;
        background: #ecf0f3;

        > .title {
          color: #121212;
          font-family: Pretendard;
          font-size: 15px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }

        > .button-wrapper {
          display: flex;
          flex-direction: row;
          gap: 10px;
          align-items: center;

          > .button {
            min-width: 38.91px;
            padding: 8px 15px;
            color: #fff;
            text-align: center;
            font-family: Pretendard;
            font-size: 15px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            border-radius: 10px;
          }

          > .button.playing {
            background: linear-gradient(
              103deg,
              #6c36d6 -22.02%,
              #955fff 54.56%,
              #ccb2ff 102.58%
            );
          }
          > .button.reservation {
            background: #fe5cee;
          }
          > .button.end {
            background: #bebebe;
          }
        }
      }
    }
  }
`;
export const ReservationWrapper = styled(PageBox)`
  flex: 926;
  height: 480px;

  > .wrapper {
    padding: 40px 30px 50px 30px;
    display: flex;
    flex-direction: column;

    > .header {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      > .drop-box-wrapper {
        cursor: pointer;
        display: flex;
        flex-direction: row;
        gap: 12px;
        padding: 7px 18px;
        color: #121212;
        font-family: Pretendard;
        font-size: 13px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        align-items: center;
        border-radius: 20px;
        background: #ecf0f3;
        position: relative;
        width: 105px;
        height: 30px;
        box-sizing: border-box;

        > img {
          width: 8px;
          height: 7px;
        }

        > .drop-box {
          position: absolute;
          top: 40px;
          display: flex;
          left: 0;
          width: 74px;
          padding: 12px;
          flex-direction: column;
          align-items: flex-start;
          gap: 4px;
          border-radius: 2.7px;
          background: #fff;
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.12);

          > .item {
            cursor: pointer;
            width: 75px;
            border-radius: 15px;
            border: 1px solid var(--Black-100, #f0f0f0);
            display: flex;
            height: 30px;
            justify-content: center;
            align-items: center;
            gap: 2px;
            align-self: stretch;
            color: var(--Black-500, #202020);
            font-family: Pretendard;
            font-size: 12px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }

          > .item.active {
            background: var(--Purple-300, #6436e7);
            color: white;
          }
        }
      }
    }

    > .chart {
      width: 100%;
      height: 180px;
    }

    > .info-wrapper {
      display: flex;
      flex-direction: row;
      padding: 0 0 0 20px;
      margin-top: 60px;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;
      > .yesterday-wrapper {
        width: 374px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;

        padding: 9.5px 20px 9.5px 10px;
        border-radius: 15px;
        background: #2f3332;
        box-shadow: 0px 0px 7.078px 0px rgba(0, 0, 0, 0.25);
        > .left {
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 10px;
          > img {
            width: 40px;
            height: 40px;
          }
          > .description {
            color: #fff;
            font-family: Pretendard;
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
          }
        }

        > .right {
          color: #fff;
          text-align: right;
          font-family: Pretendard;
          font-size: 22px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }
      }

      > .data-wrapper {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 70px;

        > .item {
          display: flex;
          flex-direction: column;
          gap: 8.27px;

          > .title {
            color: var(--kakao-logo, #000);
            font-family: Pretendard;
            font-size: 16.899px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
          }

          > .value {
            color: var(--kakao-logo, #000);
            font-family: Pretendard;
            font-size: 23.659px;
            font-style: normal;
            font-weight: 600;
            line-height: normal;
          }
        }
      }
    }
  }
`;
